var _defs, _polygon, _rect, _rect2, _polygon2, _path, _path2, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1916 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #0d0d0d;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "290.7 187.4 145 187.4 145 78.2 73 78.2 73 350.9 145 350.9 145 230.6 290.7 230.6 290.7 350.9 363.1 350.9 363.1 78.2 290.7 78.2 290.7 187.4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 422.6,
    y: 78.2,
    width: 72.9,
    height: 272.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 1770.1,
    y: 78.2,
    width: 72.9,
    height: 272.7
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "805.2 78.2 522.2 78.2 522.2 123.6 627.9 123.6 627.9 350.9 699.4 350.9 699.4 123.6 805.2 123.6 805.2 78.2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M872.3,78.6l-129.3,272.2h80.9l25.3-61h136.4l24.9,61h81.3l-128.4-272.2h-91.1ZM867.4,246.6l50.2-121.6,49.8,121.6h-100Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1241.9,315.7c-28,0-85.3-5.8-86.2-100.2-.9-89.1,51.5-101.6,86.2-101.6,34.2.4,68.4,16.5,68.9,57h73.8c-.9-49.5-43.5-96.7-142.6-97.6-73.7-.4-163,29.9-163.5,140.8-.4,110,90.6,144.3,163.5,142.6,67.1-2.2,141.7-20.9,144.8-103.8l-74.2.4c-2.2,51.7-43.5,61.9-70.6,62.4Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1640 187.4 1494.2 187.4 1494.2 78.2 1422.3 78.2 1422.3 350.9 1494.2 350.9 1494.2 230.6 1640 230.6 1640 350.9 1711.9 350.9 1711.9 78.2 1640 78.2 1640 187.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNew);
export default __webpack_public_path__ + "static/media/logo_new.3696360aad5dfb7825a843a344052d0e.svg";
export { ForwardRef as ReactComponent };